// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"7538":"recorder","9983":"profiler"}[chunkId] + "." + {"7538":"dd10078ee9d780ac","9983":"41913c6a7da5fc60"}[chunkId] + ".js";
};